<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { GravyPath } from "../../../../path";
import add from "./add.vue";
import items_list from "@/views/pages/Dilfoods/Gravy/items_list";
import Brands from "./brands.vue";
import Transfer from "./transfer.vue";
/* Dashboard component */
export default {
  components: {
    items_list,
    Layout,
    PageHeader,
    add: add,
    Brands,
    Transfer,
  },
  data() {
    return {
      title: "Gravy",
      items: [
        {
          text: "List",
        },
        {
          text: "gravies",
          active: true,
        },
      ],
      selectedGravy: {
        images: [],
      },
      gravies: [],
      base_url: process.env.VUE_APP_API_BACKEND_URL,
      cdn: process.env.VUE_APP_AWS_CDN,
      filter: [],
      fields: [
        "name",
        "items_associated",
        "shelf_life",
        "net_weight",
        "storage_condition",
        "uom",
        "units",
        "selling_price",
        "images",
        "transfer_gravy_tag",
        "brands",
        "actions",
      ],
      current_page: 1,
      search: "",
      is_copy: false,
    };
  },
  watch: {
    current_page() {
      this.getGravy();
    },
    search() {
      this.getGravy();
    },
  },
  methods: {
    async getGravy() {
      try {
        let response = await axios.get(this.base_url + GravyPath.ALL, {
          params: {
            page: this.current_page,
            search: this.search,
          },
        });
        if (response.data.status == true) {
          this.gravies = response.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    addGravy() {
      this.selectedGravy = {
        images: [],
      };
      this.$bvModal.show("bv-add-gravy");
    },
    showItemsList(v) {
      this.selectedGravy = v;
      this.$bvModal.show("bv-list-gravy-items");
    },
    reload() {
      this.getGravy();
    },
    setEdit(d) {
      this.selectedGravy = d;
      this.$bvModal.show("bv-add-gravy");
    },
    openBrands(v) {
      this.selectedGravy = v;
      this.$bvModal.show("add-brands");
    },
    TransferGravy(v, copy = false) {
      this.selectedGravy = v;
      this.is_copy = copy;
      this.$bvModal.show("transfer_gravy");
    },
    async deleteData(d) {
      try {
        let response = await axios.delete(
          this.base_url + GravyPath.ALL + "/" + d.id
        );
        if (response.data.status == true) {
          this.$bvToast.toast("Successfully Deleted", {
            title: `Gravy Deleted`,
            variant: "success",
            solid: true,
          });
          this.getGravy();
        }
      } catch (e) {
        this.$bvToast.toast("Failed to delete", {
          title: e.message,
          variant: "error",
          solid: true,
        });
        console.log(e);
      }
    },
  },
  mounted() {
    this.getGravy();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-4">
              <div class="col-md-6">
                <b-button @click="addGravy" class="btn btn-primary mb-10 pb-10"
                  >Add Gravy</b-button
                >
                <b-modal
                  id="bv-add-gravy"
                  :title="
                    (Object.keys(selectedGravy).length > 0 ? 'Edit' : 'Add') +
                    ' Gravy'
                  "
                  size="lg"
                  hide-footer
                >
                  <add @update="reload()" :selectedGravy="selectedGravy"></add>
                </b-modal>
                <b-modal
                  id="bv-list-gravy-items"
                  :title="
                    Object.keys(selectedGravy).length > 0
                      ? selectedGravy.name
                      : ''
                  "
                  hide-footer
                >
                  <items_list
                    @update="reload()"
                    :selectedGravy="selectedGravy"
                  ></items_list>
                </b-modal>
                <b-modal
                  id="add-brands"
                  :title="
                    Object.keys(selectedGravy).length > 0
                      ? selectedGravy.name
                      : ''
                  "
                  hide-footer
                >
                  <Brands :selectedGravy="selectedGravy"></Brands>
                </b-modal>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center mr-5">
                    Search:
                    <b-form-input
                      v-model="search"
                      type="search"
                      debounce="300"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                    <!-- <b-form-input v-model="filter" type="search" class="form-control form-control-sm ml-2"></b-form-input> -->
                  </label>
                </div>
              </div>
              <b-modal id="transfer_gravy" hide-footer>
                <Transfer :gravy="selectedGravy" :is_copy="is_copy"></Transfer>
              </b-modal>

              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :key="gravies.key"
                :items="gravies.data"
                :fields="fields"
                responsive="sm"
                :filter="filter"
                :current-page="current_page"
              >
                <template v-slot:cell(name)="row">
                  <img
                    src="@/assets/veg.png"
                    style="width: 25px"
                    v-if="row.item.food_type == 'veg'"
                  />
                  <img
                    src="@/assets/non_veg.png"
                    style="width: 20px"
                    v-if="row.item.food_type == 'non_veg'"
                  />
                  {{ row.item.name }}
                </template>
                <template v-slot:cell(transfer_gravy_tag)="row">
                  <b-button variant="primary" @click="TransferGravy(row.item)">
                    <i class="fa fa-exchange-alt"> Transfer</i>
                  </b-button>

                  <b-button
                    variant="primary"
                    class="mr-2 mt-2"
                    @click="TransferGravy(row.item, true)"
                  >
                    <i class="fa fa-copy"> Copy </i>
                  </b-button>
                </template>
                <template v-slot:cell(images)="row">
                  <b-img
                    v-for="(im, i) in row.item.images"
                    :src="cdn + '/' + im.img_url"
                    :key="i"
                    size="20"
                  ></b-img>
                </template>
                <template v-slot:cell(net_weight)="row">
                  {{ row.item.weight }}
                </template>
                <template v-slot:cell(items_associated)="row">
                  {{ row.item.gravy_items_count }}
                  <i
                    class="fa fa-list-alt"
                    @click="showItemsList(row.item)"
                  ></i>
                </template>
                <template v-slot:cell(brands)="row">
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="openBrands(row.item)"
                    ><i class="fa fa-list"></i
                  ></b-button>
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button @click="setEdit(row.item)" variant="primary">
                    <i class="fa fa-pen"></i>
                  </b-button>
                  <b-button
                    @click="deleteData(row.item)"
                    variant="danger"
                    class="ml-1"
                  >
                    <i class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      :key="gravies.key"
                      v-model="current_page"
                      :total-rows="gravies.total"
                      :per-page="gravies.per_page"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
